import * as tslib_1 from "tslib";
import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
import DeclineMeetingSelectionState from '../store/schema/DeclineMeetingSelectionState';
export default mutatorAction('updateAutomaticRepliesInitialState', function updateAutomaticRepliesInitialState(data) {
    var initialState = getStore().initialState;
    initialState.blockCalendarEnabled = data.blockCalendarEnabled;
    initialState.blockCalendarTitle = data.blockCalendarTitle;
    initialState.declineExistingCalendarEventsEnabled =
        data.declineExistingCalendarEventsEnabled;
    initialState.declineNewInvitationsEnabled = data.declineNewInvitationsEnabled;
    initialState.editorViewStateMessage = data.editorViewStateMessage
        ? tslib_1.__assign({}, data.editorViewStateMessage) : null;
    initialState.editorViewStateDeclineMeeting = data.editorViewStateDeclineMeeting
        ? tslib_1.__assign({}, data.editorViewStateDeclineMeeting) : null;
    initialState.editorViewStateOutsideOrg = data.editorViewStateOutsideOrg
        ? tslib_1.__assign({}, data.editorViewStateOutsideOrg) : null;
    initialState.endDate = data.endDate;
    initialState.isAutomaticReplyEnabled = data.isAutomaticReplyEnabled;
    initialState.periodicReplyEnabled = data.periodicReplyEnabled;
    initialState.sendRepliesToContactsOnlyEnabled = data.sendRepliesToContactsOnlyEnabled;
    initialState.sendRepliesOutsideOrgEnabled = data.sendRepliesOutsideOrgEnabled;
    initialState.startDate = data.startDate;
    initialState.declineMeetingSelectedCategoryKey =
        DeclineMeetingSelectionState.CreateNewMessage;
});
//# sourceMappingURL=updateAutomaticRepliesInitialState.js.map